import React, { Component } from 'react';
import { Error } from '../../components/form/Layout';
import { useForm } from 'react-final-form'
import {isEmpty} from "lodash";

function ErrorContainer ({ name, formData, ...others }) {
    const data = useForm();
    let field = data.getFieldState(name);

    if (field && field.touched) {
        if (!isEmpty(field.error)) {
            return <Error {...others} error={field.error} />;
        }
    }

    return null;
}

export default ErrorContainer;
